import { Theme } from '@mui/material';
import { createRef, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from 'tss-react/mui';
import Utils from '../../felles/Utils';
import C from '../../assets/styles/UtilsCSS';
import * as actions from '../../store/actions/index';
import { AppState } from '../../store/rootReducer';
import MenuEl from '../../models/MenuEl';
import Enums from '../../felles/Enums';

const useStyles: any = makeStyles()((theme: Theme) =>
({
  contextMenu: {
    position: 'fixed', background: 'white', border: '1px solid #ccc', boxShadow: '0px 5px 10px #999999', with: 'auto', minWidth: 250, zIndex: 3000,
  },
  /**/ contextMenuOption: {
    minHeight: 40, background: 'white', paddingTop: 10, paddingLeft: 10, borderBottom: '1px solid #ccc', minWidth: '160px', cursor: 'default',
    '&:last-child': { border: 'none', },
    '&:hover': { background: ' linear-gradient(to top, #171b3d, #333)', color: 'white', cursor: 'pointer', },
    '&:active': { color: '#e9e9e9', background: 'linear-gradient(to top, #555, #444)', },
    ' &__disabled': { color: '#999999', pointerEvents: 'none', },
  },

  [C.IPAD_10]: {
    base: {},
  },

  [C.SAMSUNG]: {
    base: {},
  },


  [C.r(theme, C.XXS, C.XXX)]: {},
  [C.r(theme, C.XS, C.XSX)]: {},
  [C.r(theme, C.SM, C.SMX)]: {},
  [C.r(theme, C.MD, C.MDX)]: {},
  [C.r(theme, C.LG, C.LGX)]: {},
  [C.r(theme, C.XL, C.XLX)]: {},
  [C.r(theme, C.XXL, C.YLX)]: {},


}));

const RightClickMenu = () => {
  const { classes } = useStyles();
  const dispatch = useDispatch();
  const contextMenuVisible = useSelector((state: AppState) => state.ui.contextMenuVisible);
  const contextMenuX = useSelector((state: AppState) => state.ui.contextMenuX);
  const contextMenuY = useSelector((state: AppState) => state.ui.contextMenuY);
  const transidRedirect = useSelector((state: AppState) => state.ui.transidRedirect);


  const menuItems: MenuEl[] = useSelector((state: AppState) => state.menuItem.menuItems);



  const ctxMeny: any = createRef();

  useEffect(() => {
    document.addEventListener('click', _handleClick);
    return () => {
      document.removeEventListener(
        'click',
        Utils.debounce(function () {
          _handleClick;
        })
      );
    };
  }, [dispatch, contextMenuVisible]);

  //
  const _handleClick = (event) => {
    const wasOutside = !(event.target.contains === ctxMeny);
    if (wasOutside && contextMenuVisible) {
      dispatch(actions.setContextMenuVisible(false));
    }
  };
  //
  const _mouseClickEventHanmdler = (event, url: string, windowed = false) => {
    event.preventDefault();
    const m: MenuEl = Utils.getTransactionsMenuItem(menuItems, url);
    if (m.tilpasset == 0) {
      //        
      if (Enums.lookupAndSwitchTransURL(url) !== url) {
        !windowed ? window.open(Utils.HOMEPAGE_CONTEXT + '/' + Enums.lookupAndSwitchTransURL(url), '_blank') : window.open(Utils.HOMEPAGE_CONTEXT + '/' + Enums.lookupAndSwitchTransURL(url), '_blank', 'location=no,status=no');
      } else {
        !windowed ? window.open(Utils.HOMEPAGE_CONTEXT + '/vse?transid=' + url, '_blank') : window.open(Utils.HOMEPAGE_CONTEXT + '/vse?transid=' + url, '_blank', 'location=no,status=no');
      }
    } else {
      !windowed ? window.open(Utils.HOMEPAGE_CONTEXT + '/' + url, '_blank') : window.open(Utils.HOMEPAGE_CONTEXT + '/' + url, '_blank', 'location=no,status=no');
    }
  };
  // 
  return (
    (contextMenuVisible || null) && (
      <div style={{ left: contextMenuX, top: contextMenuY }} ref={ctxMeny} className={classes.contextMenu}>
        <div
          className={classes.contextMenuOption}
          onClick={(e) => _mouseClickEventHanmdler(e, transidRedirect)}
        >
          Åpne <strong>{transidRedirect}</strong> i en ny fane.
        </div>
        <div
          className={classes.contextMenuOption}
          onClick={(e) => _mouseClickEventHanmdler(e, transidRedirect, true)}
        >
          Åpne <strong>{transidRedirect}</strong> i et nytt vindu.
        </div>
      </div>
    )
  );
};



export default RightClickMenu;
